import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import {
  Button, Card, Container, Stack, Table, TableBody, TableCell,
  TableContainer, TablePagination, Typography
} from '@mui/material';
import Page from '../components/Page';
import BasicBreadcrumb from '../components/BasicBreadcrumb';
import Iconify from '../components/Iconify';
import { PushNotificationGQLFunction } from '../graphql/PUSH_NOTIFICATION';
//import NotificationLodaing from '../sections/notification/NotificationLoading';
import NotificationItem from '../sections/pushNotification/NotificationItem';

export default function PushNotification() {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  //   const [searchField, setSearchField] = useState('username');
  //   const [searchInput, setSearchInput] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const { loading, data } = useQuery(PushNotificationGQLFunction.GET_ALL_PUSH_NOTIFICATION, {
    variables: { page, rowsPerPage }
  });

  useEffect(() => {
    if (!loading && data) {
      setTotal(data.pushNotifications.len);
    }
  }, [loading, data, setTotal]);

  //   useEffect(() => {
  //     setPage(0);
  //   }, [searchField, searchInput]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const bread = [
    <Typography key="1" color="text.primary">
      {t('notify.title')}
    </Typography>
  ];
  return (
    <Page title={t('notify.title')}>
      <Container maxWidth={false}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack direction="column">
            <Typography variant="h4" gutterBottom>
              {t('notify.title')}
            </Typography>
            <BasicBreadcrumb bread={bread} />
          </Stack>
          <Button
            variant="contained"
            component={RouterLink}
            to="/push-notification/send-notification"
            startIcon={<Iconify icon="eva:paper-plane-outline" />}
          >
            {t('notify.send_title')}
          </Button>
        </Stack>

        <Card>
          {/* <ListToolbar
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            field={searchField}
            setSearchField={setSearchField}
            selection={ADMIN.SEARCH_FIELDS}
          /> */}

          {/* <Scrollbar> */}
          <TableContainer>
            <Table>
              {/* <TableHead>
                <TableRow >
                  <TableCell style={{ minWidth: '200px', maxWidth: '200px' }}>This is table head</TableCell>
                </TableRow>
              </TableHead> */}
              <TableBody>
                {/* render all pushNotification here */}
                {/* <NotificationItem receivers{['username1', 'username2', 'username3', 'username4']} /> */}
                {data?.pushNotifications.pushNotifications.map((pushNotification) => {
                  return (
                    <NotificationItem
                      key={pushNotification.id}
                      receivers={pushNotification.users}
                      subject={pushNotification.subject}
                      content={pushNotification.content}
                      timeSend={pushNotification.timeSend}
                      pushNotificationId={pushNotification.id}
                    />
                  );
                })}
                {/* <NotificationLodaing /> */}
              </TableBody>
            </Table>
          </TableContainer>
          {/* </Scrollbar> */}

          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
